import { OverlayPopupMenu } from 'features/overview'
import { EditFeatureMenu } from 'features/siteMap/popupMenus/editMode/editFeature/EditFeatureMenu'
import React, { Dispatch, FC, SetStateAction, useRef } from 'react'
import { Vector2 } from 'three'
import { GeckoSiteModel, GeckoUnit } from 'types'

import { SetCameraOrientation } from './editMode/editModel/SetCameraOrientation'

interface MapPopupMenusProps {
  siteModel: GeckoSiteModel
  allUnitsAtSite: ReadonlyArray<GeckoUnit>
  showEditSiteConfigPopupMenu: Vector2 | undefined
  setShowEditSiteConfigPopupMenu: Dispatch<SetStateAction<Vector2 | undefined>>
}
export const MapPopupMenus: FC<MapPopupMenusProps> = (props) => {
  const editSiteConfigPopupRef = useRef<HTMLDivElement>(null)
  const addMarkupObjectsPopupRef = useRef<HTMLDivElement>(null)

  const popups = [editSiteConfigPopupRef, addMarkupObjectsPopupRef]

  return (
    <>
      {props.showEditSiteConfigPopupMenu && (
        <OverlayPopupMenu
          getDraggableGroup={() => popups}
          assignRef={editSiteConfigPopupRef}
          title={'Edit Site Config'}
          closeFunction={() => props.setShowEditSiteConfigPopupMenu(undefined)}
          startPosition={props.showEditSiteConfigPopupMenu}>
          <SetCameraOrientation />
        </OverlayPopupMenu>
      )}
      <EditFeatureMenu
        getDraggableGroup={() => popups}
        assignRef={addMarkupObjectsPopupRef}
        siteModel={props.siteModel}
        allUnitsAtSite={props.allUnitsAtSite}
      />
    </>
  )
}
